import React, { Component } from 'react';
import { Button, Col, DatePicker, Input, message, Modal, Row, Table } from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';

import util from '@util';
import {
  queryBooksIncomeList,
  queryBooksIncomeRemoveList,
  queryDeleteBooksIncomes,
  queryNonBusinessIncomeList,
} from '@api/finance/finance';
import getAllType from '@util/getAllType';
import { BackBtn } from '@comm/BackBtn';
import CardStatic from './CardStatic';
import DetailModal from './ModalDetail';
import RemoveModal from './ModalRemove';
import CardPayStatistic from './CardPayStatistic';
import ImportExcelModal from './ModalImportExcel';

const { confirm } = Modal;
const { RangePicker } = DatePicker;

class FinanceCapitalDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: [],
      source: 'capital',
      reStatistic: false,
      scrollY: util.pageHeight() - 310,

      pageNo: 1,
      pageSize: 20,

      endDate: null,
      beginDate: null,
      condition: '',

      uuid: '',
      loading: false,
      visible: false,
      importVisible: false,
      removeVisible: false,

      record: [],
      removeList: [],
      selectedRowKeys: [],
      removePagination: {},

      changeFlag: 1,
      deleteLoading: false,
    };
  }

  componentWillMount() {
    getAllType().then(res => {
      this.setState({ type: res });
    });

    const { isNonBusiness } = this.props.income_info;
    if (this.props.location.pathname.indexOf('statis') > 0) {
      this.setState({
        scrollY: util.pageHeight() - 210,
        source: 'statis',
      });
    }

    if (isNonBusiness) {
      this.setState({
        scrollY: util.pageHeight() - 270,
      });
    }
  }

  componentDidMount() {
    const { isFinancialM } = this.props;
    this.loadBooksIncomeList(1);
    isFinancialM && this.getBooksIncomeRemoveList(1);
  }

  // 获取流水记录列表
  loadBooksIncomeList = pageNo => {
    const params = {};
    const { pageSize, beginDate, endDate } = this.state;
    const { uuid } = this.props.params;
    if (uuid !== undefined) {
      params.bookUuid = uuid;
    }
    params.condition = this.state.condition;
    const no = this.state.pageNo;
    const current = pageNo || no;
    params.limit = pageSize;
    params.start = current;
    beginDate && (params.beginDate = beginDate.format('YYYY-MM-DD'));
    endDate && (params.endDate = endDate.format('YYYY-MM-DD'));
    this.setState({
      pageNo: current,
    });
    if (this.state.source === 'statis') {
      const { ignoreLevel, ignoreFlag, types } = this.props.income_info;
      if (ignoreLevel) {
        params.ignoreLevel = ignoreLevel;
      }
      if (ignoreFlag) {
        params.ignoreFlag = ignoreFlag;
      }
      if (types !== undefined) {
        params.types = types;
      }

      if (this.props.income_info.yearMonth) {
        params.yearMonth = this.props.income_info.yearMonth;
      } else if (this.props.income_info.date) {
        params.beginDate = moment(this.props.income_info.date[0]).format('YYYY-MM-DD');
        params.endDate = moment(this.props.income_info.date[1]).format('YYYY-MM-DD');
      }
    }
    const { isNonBusiness } = this.props.income_info;

    this.setState({
      loading: true,
    });
    if (isNonBusiness) {
      queryNonBusinessIncomeList(params).then(res => {
        if (res.statusCode === 200) {
          this.setState({
            loading: false,
            reStatistic: true,
            record: res.data,
            total: res.totalSize,
          });
        }
      });
    } else {
      queryBooksIncomeList(params).then(res => {
        if (res.statusCode === 200) {
          this.setState({
            loading: false,
            record: res.data,
            total: res.totalSize,
          });
        }
      });
    }
  };

  // 选择分页改变
  onShowSizeChange = (current, pageSize) => {
    this.setState({ pageSize }, () => {
      this.loadBooksIncomeList(1);
    });
  };

  // 获取回收箱列表
  getBooksIncomeRemoveList = current => {
    const params = {};
    params.bookUuid = this.props.params.uuid;
    params.limit = 10;
    params.start = current;
    queryBooksIncomeRemoveList(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          removeList: res.data,
          removePagination: {
            current,
            pageSize: 10,
            total: res.totalSize,
          },
        });
      } else {
        message.error(res.message);
      }
    });
  };

  // 之前留下的,我也不知道是干啥的
  handlerFlag = () => {
    this.setState({ reStatistic: false });
  };

  /** ---------------------------------------流水删除start-------------------------------------*/
  // 复选框选中
  handleSelect = selectedRowKeys => {
    this.setState({
      selectedRowKeys,
    });
  };

  // 删除确认弹窗
  showConfirm = () => {
    const _this = this;
    confirm({
      title: '确定删除选中的流水吗?',
      onOk() {
        _this.deleteRecords();
      },
      onCancel() {},
    });
  };

  // 删除接口
  deleteRecords = () => {
    const { selectedRowKeys, changeFlag } = this.state;
    this.setState({
      deleteLoading: true,
    });
    queryDeleteBooksIncomes({ uuids: selectedRowKeys }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.loadBooksIncomeList(1);
        this.getBooksIncomeRemoveList(1);
        this.setState({ changeFlag: changeFlag + 1, deleteLoading: false });
      } else {
        message.error(res.message);
      }
    });
  };

  /** ---------------------------------------流水删除end---------------------------------------*/

  /** ---------------------------------------搜索start-----------------------------------------*/
  // 记录日期
  onRangePickerChange = date => {
    this.setState({
      beginDate: date[0],
      endDate: date[1],
    });
  };

  // 记录文字
  setCondition = e => {
    this.setState({
      condition: e.target.value,
    });
  };

  search = condition => {
    this.condition = condition;
    this.loadBooksIncomeList(1);
  };
  /** ---------------------------------------搜索end-------------------------------------------*/

  /** ---------------------------------------弹窗start-----------------------------------------*/
  showModal = uuid => {
    this.setState({
      visible: true,
      uuid,
    });
  };

  // 导入弹窗
  showImport = () => {
    this.setState({ importVisible: true });
  };

  // 回收箱弹窗
  showRemove = () => {
    this.setState({ removeVisible: true });
  };

  // 关闭所有弹窗
  handleCancel = () => {
    this.setState({
      visible: false,
      importVisible: false,
      removeVisible: false,
    });
  };

  // 弹窗提交后
  handleSubmit = result => {
    if (result) {
      this.handleCancel();
      this.loadBooksIncomeList();
    }
  };
  /** ---------------------------------------弹窗end-------------------------------------------*/

  // 返回按钮
  columns = () => {
    const { type, source } = this.state;
    const {
      income_info: { isNonBusiness },
    } = this.props;
    const config = [
      {
        title: '日期',
        dataIndex: 'date',
        key: 'date',
        width: 250,
        render: (text, record) => {
          let ignoreName;
          switch (record.ignore) {
            case 0:
              ignoreName = '';
              break;
            case 1:
              ignoreName = '(非业务数据)';
              break;
            case 2:
              ignoreName = '(走账数据)';
              break;
            default:
              ignoreName = '';
              break;
          }
          return (
            <a onClick={() => this.showModal(record.uuid)}>
              {moment.unix(text / 1000).format('YYYY-MM-DD')} {ignoreName}
            </a>
          );
        },
      },
      {
        title: '对方户名',
        dataIndex: 'accountName',
        key: 'accountName',
        width: 200,
      },
      {
        title: '摘要',
        dataIndex: 'remark',
        key: 'remark',
        width: 200,
      },
      {
        title: '收支类型',
        dataIndex: 'type',
        key: 'type',
        width: 200,
        render: text => {
          let typeName = '';
          if (type.length > 0) {
            type.forEach(item => {
              if (text === item.value) {
                typeName = item.key;
                return typeName;
              }
            });
          }
          return <span>{typeName}</span>;
        },
      },
      {
        title: '收入(元)',
        dataIndex: 'money',
        key: 'money',
        width: 200,
        render: (text, record) => {
          if (record.target === 1)
            return (
              <a style={{ color: 'green' }}>
                {text === 0 ? '' : util.numberFormat(text, 2, '.', ',')}
              </a>
            );
        },
      },
      {
        title: '支出(元)',
        dataIndex: 'payMoney',
        key: 'payMoney',
        width: 200,
        render: (text, record) => {
          if (record.target === 0)
            return (
              <a style={{ color: 'red' }}>
                {text === 0 ? '' : util.numberFormat(text, 2, '.', ',')}
              </a>
            );
        },
      },
      {
        title: '当前余额(元)',
        dataIndex: 'current',
        key: 'current',
        width: 200,
        render: (text, record) => (
          <span>
            <a>{text === 0 ? '' : util.numberFormat(text, 2, '.', ',')}</a>
            {source === 'capital' && !isNonBusiness && !record.isReal ? (
              <span style={{ color: 'red' }}>(出错)</span>
            ) : (
              ''
            )}
          </span>
        ),
      },
    ];

    return config;
  };

  render() {
    const {
      source,
      scrollY,

      changeFlag,
      reStatistic,
      deleteLoading,

      record,
      loading,
      removeList,
      removeVisible,
      removePagination,

      beginDate,
      endDate,
    } = this.state;

    const {
      isFinancialM,
      income_info: { isNonBusiness },
    } = this.props;

    const pagination = {
      defaultPageSize: 20,
      showSizeChanger: true,
      total: this.state.total,
      current: this.state.pageNo,
      onShowSizeChange: this.onShowSizeChange,
      pageSizeOptions: [20, 50, 100, 200, 500, 1000, 2000, 5000],
      onChange: current => {
        this.loadBooksIncomeList(current);
      },
    };

    return (
      <div>
        <div>
          <div>
            <Row type="flex" justify="space-between" style={{ marginBottom: '16px' }}>
              <Col>
                <BackBtn />
                {source === 'statis' || !isFinancialM ? (
                  ''
                ) : (
                  <Button icon="import" style={{ marginLeft: '10px' }} onClick={this.showImport}>
                    导入
                  </Button>
                )}
                {isFinancialM ? (
                  <Button
                    icon="delete"
                    loading={deleteLoading}
                    onClick={this.showConfirm}
                    style={{ marginLeft: '10px' }}
                  >
                    删除
                  </Button>
                ) : (
                  ''
                )}
                {isFinancialM ? (
                  <Button
                    icon="delete"
                    style={{ marginLeft: '10px' }}
                    onClick={() => this.showRemove(true)}
                  >
                    回收箱
                  </Button>
                ) : (
                  ''
                )}
              </Col>
              <Col>
                {source === 'statis' ? (
                  ''
                ) : (
                  <RangePicker
                    format="YYYY-MM-DD"
                    onChange={this.onRangePickerChange}
                    style={{ marginRight: '10px', verticalAlign: 'bottom' }}
                  />
                )}

                <Input
                  placeholder="请输入关键字"
                  style={{ width: '300px' }}
                  value={this.state.condition}
                  onChange={this.setCondition}
                />
                <Button
                  type="primary"
                  style={{ marginLeft: '10px' }}
                  onClick={() => {
                    this.loadBooksIncomeList(1);
                    this.setState({ changeFlag: changeFlag + 1 });
                  }}
                >
                  搜索
                </Button>
              </Col>
            </Row>
          </div>
          {source === 'statis' ? (
            ''
          ) : (
            <CardStatic
              uuid={this.props.params.uuid}
              beginDate={beginDate}
              endDate={endDate}
              changeFlag={changeFlag}
            />
          )}
          {isNonBusiness ? (
            <CardPayStatistic reStatistic={reStatistic} handlerFlag={this.handlerFlag} />
          ) : (
            ''
          )}
        </div>
        <Table
          rowKey="uuid"
          loading={loading}
          rowSelection={{
            onChange: this.handleSelect,
          }}
          dataSource={record}
          scroll={{ y: scrollY }}
          pagination={pagination}
          columns={this.columns()}
          rowClassName={row => {
            if (row.ignore === 1) {
              return 'table-ignore-1';
            }
            if (row.ignore === 2) {
              return 'table-ignore-2';
            }
          }}
        />
        {this.state.visible && isFinancialM ? (
          <DetailModal
            ref={form => {
              this.form = form;
            }}
            uuid={this.state.uuid}
            cancel={this.handleCancel}
            handleSubmit={this.handleSubmit}
          />
        ) : (
          ''
        )}
        {this.state.importVisible ? (
          <ImportExcelModal
            ref={form => {
              this.form = form;
            }}
            uuid={this.props.params.uuid}
            cancel={this.handleCancel}
            handleSubmit={this.handleSubmit}
          />
        ) : (
          ''
        )}
        <RemoveModal
          data={removeList}
          visible={removeVisible}
          pagination={removePagination}
          onChange={this.getBooksIncomeRemoveList}
          onCancel={this.handleCancel}
        />
      </div>
    );
  }
}

export default connect(state => ({
  isFinancialM: state.account_info.isFinancialM,
  account_info: state.account_info,
  income_info: state.income_info,
}))(FinanceCapitalDetail);



// WEBPACK FOOTER //
// ./src/components/finance/capital/detail/Index.js